import React from 'react';

class Test extends React.Component {
    render() {
        return(
            <p>TestyTesty</p>
        )
    }
}

export default Test;